import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import DashboardLayout from "@/pages/DashboardLayout";
import DashboardOverview from "@/pages/DashboardOverview";
import DashboardSales from "@/pages/DashboardSales";
import DashboardMarket from "@/pages/DashboardMarket";
import DashboardChat from "@/pages/DashboardChat";
import DashboardMessages from "@/pages/DashboardMessages";
import DashboardLeads from "@/pages/DashboardLeads";
import DashboardApplications from "@/pages/DashboardApplications";
import DashboardSettings from "@/pages/DashboardSettings";
import FoundingMemberDetail from "@/pages/FoundingMemberDetail";

function AppRouter() {
  const location = useLocation();

  // Handle Emergent OAuth redirect: lands as /dashboard#session_id=...
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/founding/:memberId" element={<FoundingMemberDetail />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardOverview />} />
        <Route path="sales" element={<DashboardSales />} />
        <Route path="market" element={<DashboardMarket />} />
        <Route path="chat" element={<DashboardChat />} />
        <Route
          path="messages"
          element={
            <ProtectedRoute adminOnly>
              <DashboardMessages />
            </ProtectedRoute>
          }
        />
        <Route
          path="leads"
          element={
            <ProtectedRoute adminOnly>
              <DashboardLeads />
            </ProtectedRoute>
          }
        />
        <Route
          path="applications"
          element={
            <ProtectedRoute adminOnly>
              <DashboardApplications />
            </ProtectedRoute>
          }
        />
        <Route path="settings" element={<DashboardSettings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-[#0a0a0b] text-white min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
